import FeedbackSuccess from './FeedbackSuccess';

export default FeedbackSuccess;
